export default __webpack_public_path__ + "static/create-annotation-dark-mode-d1b9d00f7f56c38bc0b614ea48c8cb62.mp4";